module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAwUlEQVQ4T2M84K56R4zlvzIDDcCrP4x3GU96qF7gZf6vj818dumfDEyc/xi+3+Eky/rPfxkvoljAKvSbAWTol8s8cAOZOP+C2f++M5NsCYoFPLpfGHjNPjMwc/1j+HSSl+HTKT64gcIe7xje7hCizAKQbrmyRwzs0r8Y7lYokuVidBdgBBGf2SeG3+9YweqQw51qPkB3ASz8qRIH2AIYFOksQn+ol4pIjkUCGjDiYNQCgsl0NIiwBhEti+vXfxjvAADKkIp108Y5swAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chinese.png
// module id = 256
// module chunks = 0